import api from './create-api';
import { responseFormatter } from '@utils';

const get = async uid => {
  // return responseFormatter(
  //   api.get(`sfdc/account/${uid}`, {
  //     setAuthHeader: true,
  //   })
  // );
};

export default {
  get,
};
